// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30RtQ","comment":"styles_comment__26FPO"};